export const YES_NO = [
  {
    text: 'Yes',
    value: true
  },
  {
    text: 'No',
    value: false
  }
]

export const YES_NO_NOTSURE = [
  {
    text: 'Yes',
    value: 'Yes'
  },
  {
    text: 'No',
    value: 'No',
  },
  {
    text: 'Not Sure',
    value: 'Not Sure'
  }
]

export const AUTHORIZED = [
  {
    text: 'Yes',
    value: 'Yes'
  },
  {
    text: 'No',
    value: 'No'
  },
  {
    text: 'Unsure',
    value: 'Unsure'
  }
]

export const REASONS = [
  {
    text: 'Primary Care',
    value: 'Primary Care'
  },
  {
    text: 'Specialist',
    value: 'Specialist',
  },
  {
    text: 'Mental Health Services',
    value: 'Mental Health Services'
  },
  {
    text: 'Other',
    value: 'Other'
  }
]

export const DISTANCE = [
  {
    text: 'Less than 30 min',
    value: 'Less than 30 min'
  },
  {
    text: 'Greater than 30 min but less than 60 min',
    value: 'Greater than 30 min but less than 60 min',
  },
  {
    text: 'Greater than 60 min',
    value: 'Greater than 60 min'
  },
  {
    text: 'Don\'t Know',
    value: 'Don\'t Know'
  }
]

export const WAIT_TIME = [
  {
    text: 'Wait time over 28 days',
    value: 'Wait time over 28 days'
  },
  {
    text: 'Wait time between 20-28 days',
    value: 'Wait time between 20-28 days'
  },
  {
    text: 'Wait time below 20 days',
    value: 'Wait time below 20 days'
  }
]

export const QUALIFY = [
  {
    text: 'Eligible for Choice Program',
    value: 'Eligible for Choice Program',
  },
  {
    text: 'VA does not offer service',
    value: 'VA does not offer service'
  },
  {
    text: 'Reside in New Hampshire, Alaska, Wyoming or Hawaii',
    value: 'Reside in New Hampshire, Alaska, Wyoming or Hawaii',
  },
  {
    text: 'VA does not meet quality',
    value: 'VA does not meet quality'
  },
  {
    text: 'None Apply',
    value: 'None Apply'
  }
]

export const VISIT = [
  {
    text: 'VA Healthcare Benefits',
    value: 'VA Healthcare Benefits'
  },
  {
    text: 'Private Insurance',
    value: 'Private Insurance',
  },
  {
    text: 'Medicare/Medicaid',
    value: 'Medicare/Medicaid'
  },
  {
    text: 'Self Pay',
    value: 'Self Pay'
  },
  {
    text: 'Other',
    value: 'Other'
  }
]
